import {
  config
} from '@peckhamcc/config'

export default config
